import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconArrowDropUpLine = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.68 13.75a.421.421 0 0 1-.327-.137.46.46 0 0 1-.124-.32c0-.03.047-.135.14-.316l3.151-3.15a.638.638 0 0 1 .48-.209.639.639 0 0 1 .48.208l3.151 3.151a.512.512 0 0 1 .102.146.458.458 0 0 1-.087.492.423.423 0 0 1-.327.135H8.681Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconArrowDropUpLine;
